import React from 'react'

import { Col, Grid } from '../../../../packages/kiti/components/structure/Grid'
import FormItem from '../../../../packages/kiti/components/form/form/FormItem'

const GeneralSection = () => {
  return (
    <Grid paddingGutter={0.5} wrap>
      <Col width="100%" wrapOn="sm">
        <FormItem label="Nome*" field="name" />
      </Col>
    </Grid>
  )
}

export default GeneralSection
